/* eslint-disable max-len */
import clsx from 'clsx';

type ToDoIconProps = {
  className?: string;
  color?: string;
};

export const ToDoIcon = ({ className, color = '#0069E4' }: ToDoIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      className={clsx('icon', className)}
      aria-hidden="true"
      focusable="false"
    >
      <g id="2-5 icons To Do ">
        <path
          id="Rectangle 5139"
          d="M19.5491 25.78L20.1881 23.7008L28.7489 15.1212L30.1876 16.5568L21.6268 25.1364L19.5491 25.78Z"
          fill={color}
          stroke={color}
          strokeWidth="3"
        />
        <path
          id="Vector 13"
          d="M7.5 9H24.5M7.5 17.1304H17.5M7.5 26H14.5"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Rectangle 5140"
          d="M33.06 13.4928L31.6213 12.0573L32.5553 11.1212L33.994 12.5568L33.06 13.4928Z"
          stroke={color}
          strokeWidth="3"
        />
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 33V3H29.5V9.78487L32.5 7.21219V2C32.5 0.895431 31.6046 0 30.5 0H2.5C1.39543 0 0.5 0.895431 0.5 2V34C0.5 35.1046 1.39543 36 2.5 36H30.5C31.6046 36 32.5 35.1046 32.5 34V18.5145L29.5 21.5444V33H3.5Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
